import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeeplinkParamsBuilder {
  public generateDeeplinkParams(values: Map<string, string>): string {
    let acc = '';
    values.forEach((value: string, key: string) => {
      acc += `&${key}=${value}`;
    });
    return acc;
  }
}
